// extracted by mini-css-extract-plugin
module.exports = {"title__byline":"title_title__byline__8drK3","title__byline_small":"title_title__byline_small__gG5I6"};